// drawerSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';

interface DrawerState {
  isOpen: boolean;
  content: React.ReactNode;
  onClose: (() => void) | null;
  onSubmit: (() => void) | null;
  header: string | null;
  data: any;
  currentPage: number;
  itemsPerPage: number;
  crossFilterLoading: boolean;
  loading?: boolean;
  totalPages: number;
}

const initialState: DrawerState = {
  isOpen: false,
  content: null,
  onClose: null,
  onSubmit: null,
  header: null,
  data: [],
  itemsPerPage: 20,
  currentPage: 1,
  crossFilterLoading: false,
  loading: false,
  totalPages: 0,
};

const drawerSlice = createSlice({
  name: 'drawer',
  initialState,
  reducers: {
    openDrawer: (
      state,
      action: PayloadAction<{
        content?: React.ReactNode;
        onClose?: () => void;
        onSubmit?: () => void;
        header?: string;
        data?: any;
        totalPages?: number;
        crossFilterLoading?: boolean;
      }>,
    ) => {
      state.isOpen = true;
      state.content = action.payload.content;
      state.crossFilterLoading = action.payload.crossFilterLoading || false;
      state.onClose = action.payload.onClose || null;
      state.onSubmit = action.payload.onSubmit || null;
      state.header = action.payload.header || null;
      state.data = action.payload.data || null;
      state.totalPages = action.payload.totalPages || 0;
    },
    closeDrawer: (state) => {
      state.isOpen = false;
      state.content = null;
      state.onClose = null;
      state.onSubmit = null;
      state.header = null;
      state.data = [];
      state.currentPage = 1;
      state.loading = false;
      state.totalPages = 0;
    },
    updatePage: (state) => {
      state.currentPage += 1;
    },
    fetchMoreDataRequest: (state) => {
      state.loading = true;
    },
    fetchMoreDataSuccess: (state, action: PayloadAction<any>) => {
      state.data = [...state.data, ...action.payload];
      state.loading = false;
    },
    fetchMoreDataFailure: (state) => {
      state.loading = false;
    },
  },
});

export const { openDrawer, closeDrawer, updatePage, fetchMoreDataRequest, fetchMoreDataSuccess, fetchMoreDataFailure } = drawerSlice.actions;

export default drawerSlice.reducer;
